// @generated by protoc-gen-es v2.2.2 with parameter "target=ts"
// @generated from file ga/config_manager/casinokey/casinokey.proto (package ga.config_manager.casinokey, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file ga/config_manager/casinokey/casinokey.proto.
 */
export const file_ga_config_manager_casinokey_casinokey: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * @generated from message ga.config_manager.casinokey.GenerateRequest
 */
export type GenerateRequest = Message<"ga.config_manager.casinokey.GenerateRequest"> & {
  /**
   * @generated from field: string casino_id = 1;
   */
  casinoId: string;
};

/**
 * Describes the message ga.config_manager.casinokey.GenerateRequest.
 * Use `create(GenerateRequestSchema)` to create a new message.
 */
export const GenerateRequestSchema: GenMessage<GenerateRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinokey_casinokey, 0);

/**
 * @generated from message ga.config_manager.casinokey.GenerateResponse
 */
export type GenerateResponse = Message<"ga.config_manager.casinokey.GenerateResponse"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;
};

/**
 * Describes the message ga.config_manager.casinokey.GenerateResponse.
 * Use `create(GenerateResponseSchema)` to create a new message.
 */
export const GenerateResponseSchema: GenMessage<GenerateResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinokey_casinokey, 1);

/**
 * @generated from message ga.config_manager.casinokey.RolloutRequest
 */
export type RolloutRequest = Message<"ga.config_manager.casinokey.RolloutRequest"> & {
  /**
   * @generated from field: string casino_id = 1;
   */
  casinoId: string;
};

/**
 * Describes the message ga.config_manager.casinokey.RolloutRequest.
 * Use `create(RolloutRequestSchema)` to create a new message.
 */
export const RolloutRequestSchema: GenMessage<RolloutRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinokey_casinokey, 2);

/**
 * @generated from message ga.config_manager.casinokey.RolloutResponse
 */
export type RolloutResponse = Message<"ga.config_manager.casinokey.RolloutResponse"> & {
};

/**
 * Describes the message ga.config_manager.casinokey.RolloutResponse.
 * Use `create(RolloutResponseSchema)` to create a new message.
 */
export const RolloutResponseSchema: GenMessage<RolloutResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinokey_casinokey, 3);

/**
 * @generated from message ga.config_manager.casinokey.CasinoKeyInfo
 */
export type CasinoKeyInfo = Message<"ga.config_manager.casinokey.CasinoKeyInfo"> & {
  /**
   * @generated from field: string casino_id = 1;
   */
  casinoId: string;

  /**
   * @generated from field: string key_obfuscated = 2;
   */
  keyObfuscated: string;

  /**
   * @generated from field: ga.config_manager.casinokey.CasinoKeyState state = 3;
   */
  state: CasinoKeyState;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string last_action_by = 6;
   */
  lastActionBy: string;

  /**
   * why the apply of the key failed, set in FAILED_APPLYING_NEW_KEY and FAILED_ROLLING_OUT
   *
   * @generated from field: string last_error = 7;
   */
  lastError: string;
};

/**
 * Describes the message ga.config_manager.casinokey.CasinoKeyInfo.
 * Use `create(CasinoKeyInfoSchema)` to create a new message.
 */
export const CasinoKeyInfoSchema: GenMessage<CasinoKeyInfo> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinokey_casinokey, 4);

/**
 * @generated from message ga.config_manager.casinokey.VerifyRequest
 */
export type VerifyRequest = Message<"ga.config_manager.casinokey.VerifyRequest"> & {
  /**
   * @generated from field: string casino_id = 1;
   */
  casinoId: string;
};

/**
 * Describes the message ga.config_manager.casinokey.VerifyRequest.
 * Use `create(VerifyRequestSchema)` to create a new message.
 */
export const VerifyRequestSchema: GenMessage<VerifyRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinokey_casinokey, 5);

/**
 * @generated from message ga.config_manager.casinokey.VerifyResponse
 */
export type VerifyResponse = Message<"ga.config_manager.casinokey.VerifyResponse"> & {
};

/**
 * Describes the message ga.config_manager.casinokey.VerifyResponse.
 * Use `create(VerifyResponseSchema)` to create a new message.
 */
export const VerifyResponseSchema: GenMessage<VerifyResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinokey_casinokey, 6);

/**
 * @generated from message ga.config_manager.casinokey.NewCasinoKeyRequest
 */
export type NewCasinoKeyRequest = Message<"ga.config_manager.casinokey.NewCasinoKeyRequest"> & {
  /**
   * @generated from field: string casino_id = 1;
   */
  casinoId: string;

  /**
   * @generated from field: bool create_main_key = 4;
   */
  createMainKey: boolean;

  /**
   * @generated from field: bool create_secondary_key = 5;
   */
  createSecondaryKey: boolean;

  /**
   * @generated from field: string path_vault = 6;
   */
  pathVault: string;
};

/**
 * Describes the message ga.config_manager.casinokey.NewCasinoKeyRequest.
 * Use `create(NewCasinoKeyRequestSchema)` to create a new message.
 */
export const NewCasinoKeyRequestSchema: GenMessage<NewCasinoKeyRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinokey_casinokey, 7);

/**
 * @generated from message ga.config_manager.casinokey.NewCasinoKeyResponse
 */
export type NewCasinoKeyResponse = Message<"ga.config_manager.casinokey.NewCasinoKeyResponse"> & {
  /**
   * @generated from field: string path_vault = 1;
   */
  pathVault: string;

  /**
   * @generated from field: bool main_key_exists = 2;
   */
  mainKeyExists: boolean;

  /**
   * @generated from field: bool secondary_key_exists = 3;
   */
  secondaryKeyExists: boolean;
};

/**
 * Describes the message ga.config_manager.casinokey.NewCasinoKeyResponse.
 * Use `create(NewCasinoKeyResponseSchema)` to create a new message.
 */
export const NewCasinoKeyResponseSchema: GenMessage<NewCasinoKeyResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinokey_casinokey, 8);

/**
 * @generated from message ga.config_manager.casinokey.ListCasinosRequest
 */
export type ListCasinosRequest = Message<"ga.config_manager.casinokey.ListCasinosRequest"> & {
};

/**
 * Describes the message ga.config_manager.casinokey.ListCasinosRequest.
 * Use `create(ListCasinosRequestSchema)` to create a new message.
 */
export const ListCasinosRequestSchema: GenMessage<ListCasinosRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinokey_casinokey, 9);

/**
 * @generated from message ga.config_manager.casinokey.ListCasinosResponse
 */
export type ListCasinosResponse = Message<"ga.config_manager.casinokey.ListCasinosResponse"> & {
  /**
   * @generated from field: repeated ga.config_manager.casinokey.ListCasinosResponse.Casino casinos = 1;
   */
  casinos: ListCasinosResponse_Casino[];
};

/**
 * Describes the message ga.config_manager.casinokey.ListCasinosResponse.
 * Use `create(ListCasinosResponseSchema)` to create a new message.
 */
export const ListCasinosResponseSchema: GenMessage<ListCasinosResponse> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinokey_casinokey, 10);

/**
 * @generated from message ga.config_manager.casinokey.ListCasinosResponse.Casino
 */
export type ListCasinosResponse_Casino = Message<"ga.config_manager.casinokey.ListCasinosResponse.Casino"> & {
  /**
   * @generated from field: string casino_id = 1;
   */
  casinoId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string jurisdiction = 3;
   */
  jurisdiction: string;

  /**
   * @generated from field: string key_obfuscated = 16;
   */
  keyObfuscated: string;

  /**
   * @generated from field: ga.config_manager.casinokey.CasinoKeyState state = 17;
   */
  state: CasinoKeyState;

  /**
   * @generated from field: string last_action_by = 18;
   */
  lastActionBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 19;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 20;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: string last_error = 21;
   */
  lastError: string;
};

/**
 * Describes the message ga.config_manager.casinokey.ListCasinosResponse.Casino.
 * Use `create(ListCasinosResponse_CasinoSchema)` to create a new message.
 */
export const ListCasinosResponse_CasinoSchema: GenMessage<ListCasinosResponse_Casino> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_casinokey_casinokey, 10, 0);

/**
 * @generated from enum ga.config_manager.casinokey.CasinoKeyState
 */
export enum CasinoKeyState {
  /**
   * no state: the casino has no row yet, or the db holds an unknown one; at rest, Generate
   * starts a rotation
   *
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * at rest: the key in Vault is deployed and the old one is gone; Generate starts a rotation
   *
   * @generated from enum value: ACTIVATED = 1;
   */
  ACTIVATED = 1,

  /**
   * the new key is in the secondary slot in Vault, beside the old primary one; the tick
   * snapshots the pods, once they all run, and starts the apply
   *
   * @generated from enum value: READY_FOR_APPLYING_NEW_KEY = 2;
   */
  READY_FOR_APPLYING_NEW_KEY = 2,

  /**
   * the configs with both keys are being applied in the background; when all the services are
   * applied after the key got into Vault and the pods of the snapshot are replaced, the casino
   * goes to KEY_DEPLOYMENT, on a failure or after apply_timeout to FAILED_APPLYING_NEW_KEY
   *
   * @generated from enum value: APPLYING_NEW_KEY = 3;
   */
  APPLYING_NEW_KEY = 3,

  /**
   * both keys are deployed: the provider may switch to the new one; Rollout removes the old
   * key, Generate starts the rotation over
   *
   * @generated from enum value: KEY_DEPLOYMENT = 4;
   */
  KEY_DEPLOYMENT = 4,

  /**
   * Rollout copied the new key to the primary slot in Vault (a casino with a single key comes
   * here from Generate, its new key is the primary one already); the tick snapshots the pods,
   * once they all run, and starts the apply
   *
   * @generated from enum value: READY_FOR_ROLLING_OUT = 5;
   */
  READY_FOR_ROLLING_OUT = 5,

  /**
   * the configs with the new key only are being applied in the background; when all the
   * services are applied after the key got into Vault and the pods of the snapshot are
   * replaced, the casino goes to ACTIVATED, on a failure or after apply_timeout to
   * FAILED_ROLLING_OUT
   *
   * @generated from enum value: ROLLING_OUT = 6;
   */
  ROLLING_OUT = 6,

  /**
   * Generate started: the new key is not in Vault yet, or writing it failed; no timeout, only
   * Generate repeats it
   *
   * @generated from enum value: STARTING_APPLYING_NEW_KEY = 7;
   */
  STARTING_APPLYING_NEW_KEY = 7,

  /**
   * Rollout started: the secondary key is not copied to the primary yet, or copying failed; no
   * timeout, only Rollout repeats it
   *
   * @generated from enum value: STARTING_ROLLING_OUT = 8;
   */
  STARTING_ROLLING_OUT = 8,

  /**
   * the apply of the new key was interrupted, failed or timed out, last_error tells why; no
   * retry: a successful deploy of the services not applied, from the deploy page or by another
   * casino, moves the casino on to KEY_DEPLOYMENT; Generate starts the rotation over
   *
   * @generated from enum value: FAILED_APPLYING_NEW_KEY = 9;
   */
  FAILED_APPLYING_NEW_KEY = 9,

  /**
   * the apply after Rollout was interrupted, failed or timed out, last_error tells why; no
   * retry: a successful deploy of the services not applied, from the deploy page or by another
   * casino, moves the casino on to ACTIVATED; Rollout repeats the rollout
   *
   * @generated from enum value: FAILED_ROLLING_OUT = 10;
   */
  FAILED_ROLLING_OUT = 10,
}

/**
 * Describes the enum ga.config_manager.casinokey.CasinoKeyState.
 */
export const CasinoKeyStateSchema: GenEnum<CasinoKeyState> = /*@__PURE__*/
  enumDesc(file_ga_config_manager_casinokey_casinokey, 0);

/**
 * @generated from service ga.config_manager.casinokey.CasinoKeyService
 */
export const CasinoKeyService: GenService<{
  /**
   * @generated from rpc ga.config_manager.casinokey.CasinoKeyService.Generate
   */
  generate: {
    methodKind: "unary";
    input: typeof GenerateRequestSchema;
    output: typeof GenerateResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinokey.CasinoKeyService.Rollout
   */
  rollout: {
    methodKind: "unary";
    input: typeof RolloutRequestSchema;
    output: typeof RolloutResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinokey.CasinoKeyService.Verify
   */
  verify: {
    methodKind: "unary";
    input: typeof VerifyRequestSchema;
    output: typeof VerifyResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinokey.CasinoKeyService.NewCasinoKey
   */
  newCasinoKey: {
    methodKind: "unary";
    input: typeof NewCasinoKeyRequestSchema;
    output: typeof NewCasinoKeyResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.casinokey.CasinoKeyService.ListCasinos
   */
  listCasinos: {
    methodKind: "unary";
    input: typeof ListCasinosRequestSchema;
    output: typeof ListCasinosResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_ga_config_manager_casinokey_casinokey, 0);

